import React from 'react';
import { CheckCircle2, Target, Lightbulb, Star } from 'lucide-react';
import Footer from '../components/Footer';

const AboutUs = () => {
  return (
    <div className="min-h-screen bg-white">
      <div className="pt-32 pb-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <header className="text-center mb-16">
          <span className="text-[#7d5800] font-bold text-sm uppercase tracking-wider">About Us</span>
          <h1 className="text-5xl md:text-6xl font-bold text-[#123f1e] mt-4">
            School Initiative
          </h1>
        </header>

        {/* Mission Section */}
        <div className="grid lg:grid-cols-2 gap-12 items-center mb-20">
          <div>
            <img
              src="https://goldprekd9.com/wp-content/uploads/2023/06/schoolImg.png"
              alt="Garden of Learning & Discovery Pre-K school building exterior"
              className="rounded-2xl shadow-xl"
            />
          </div>
          <div className="space-y-6">
            <div className="flex items-start gap-4">
              <div className="p-3 bg-[#febc04]/10 rounded-xl">
                <Target className="w-6 h-6 text-[#123f1e]" />
              </div>
              <div>
                <h2 className="text-3xl font-bold text-[#123f1e] mb-4">Our Mission</h2>
                <p className="text-gray-700 leading-relaxed">
                  The mission of the Garden of Learning and Discovery Pre-K Center (GoLD) is to create a safe, nurturing, and collaborative community where children are inspired and encouraged to become problem solvers, creative thinkers, and global citizens through the utilization of developmentally appropriate play-based learning and literacy-rich responsive instruction. The foundation for life-long learning starts at GoLD!
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Vision Section */}
        <div className="bg-[#123f1e] rounded-3xl p-12 text-white mb-20">
          <div className="flex items-start gap-4 mb-6">
            <div className="p-3 bg-[#febc04] rounded-xl">
              <Lightbulb className="w-6 h-6 text-[#123f1e]" />
            </div>
            <h2 className="text-3xl font-bold">The Vision</h2>
          </div>
          <p className="text-white/90 leading-relaxed text-lg">
            At Garden of Learning and Discovery Pre-K Center, we are committed to the core principles of fairness, equity, and justice by fostering a Culturally Responsive environment that recognizes and appreciates the diversity and uniqueness of all staff, students, and families. The vision of GoLD is to recognize and celebrate the whole child by enhancing the cognitive, creative, social, emotional, physical, and academic skills of all children by providing an exceptional early childhood education leading to independence.
          </p>
        </div>

        {/* Community Image */}
        <div className="mb-20">
          <img
            src="/assets/images/gallery/District9PreK-147.jpg"
            alt="GoLD Pre-K students learning together in a group activity"
            className="w-full h-96 object-cover rounded-3xl shadow-xl"
          />
        </div>

        {/* Instructional Focus */}
        <div className="grid md:grid-cols-2 gap-12 mb-20">
          <div className="bg-white border-2 border-gray-200 rounded-2xl p-8 hover:border-[#febc04] transition-all">
            <div className="flex items-center gap-3 mb-6">
              <div className="p-3 bg-[#febc04]/10 rounded-xl">
                <Star className="w-6 h-6 text-[#123f1e]" />
              </div>
              <h2 className="text-2xl font-bold text-[#123f1e]">Instructional Focus</h2>
            </div>
            <p className="text-gray-700 leading-relaxed">
              We aim to cultivate a literacy-rich school culture and environment that creates opportunities for early learners to actively engage in the 21st century. We prioritize developing a strong sense of self-awareness while building knowledge, skills, and language acquisition by incorporating literacy opportunities and increasing language modeling which leads to student independence.
            </p>
          </div>

          <div className="bg-white border-2 border-gray-200 rounded-2xl p-8 hover:border-[#febc04] transition-all">
            <div className="flex items-center gap-3 mb-6">
              <div className="p-3 bg-[#febc04]/10 rounded-xl">
                <CheckCircle2 className="w-6 h-6 text-[#123f1e]" />
              </div>
              <h2 className="text-2xl font-bold text-[#123f1e]">Priority Focus</h2>
            </div>
            <p className="text-gray-700 leading-relaxed">
              Build teacher capacity around language modeling and developmentally appropriate literacy skills without compromising learning through play.
            </p>
          </div>
        </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default AboutUs;
